import { supabase } from "@/integrations/supabase/client";

/**
 * One-time function to populate the curated visa data table
 * This should be called once during initial setup
 */
export async function populateCuratedVisaData() {
  try {
    const { data, error } = await supabase.functions.invoke('populate-curated-visa-data', {
      body: {}
    });

    if (error) {
      console.error('Error populating curated visa data:', error);
      throw error;
    }

    console.log('Curated visa data populated successfully:', data);
    return data;
  } catch (error) {
    console.error('Failed to populate curated visa data:', error);
    throw error;
  }
}